import { Link, useParams } from "react-router-dom";
import {
  getTournamentSlugByOrganizerSlug,
} from "../network/lib/APIs";
import { useEffect, useState } from "react";
import { getSubdomainApp } from "../utils/helpers";

const TouranamentList = () => {
 
  const [tournamentSlugArray, setTournamentSlug] = useState([]);
  const [organizer_slug, setOrganizerSlug] = useState("");

  useEffect(() => {
    const subdomain = getSubdomainApp(window.location.hostname);

    // Check if the subdomain ends with "-qa"
    if (subdomain.endsWith("-qa")) {
      // Remove the "-qa" part from the subdomain
      const updatedSubdomain = subdomain.slice(0, -3);
      setOrganizerSlug(updatedSubdomain);
    } else {
      setOrganizerSlug(subdomain);
    }
  }, [organizer_slug]);

  console.log("organizer_slug", organizer_slug);

  
  useEffect(() => {
    fetchTournamentSlugByOrganizerSlug();
  }, [organizer_slug]);

  // useEffect(() => {
  //   checkOrganizerSlug();
  // }, [organizer_slug]);
  // useEffect(() => {
  //   console.log("organizer slug response:", validationResult);
  // }, [validationResult]);

//   const checkOrganizerSlug = async () => {
//     try {
//       if (!organizer_slug) {
//         throw new Error("Tournament name is undefined");
//       }
//       const response: any = await checkOrganizationSlug(organizer_slug);
// 
//       console.log("response1:", response.data);
//       setValidationResult(response.data.validation_status);
//     } catch (error) {
//       console.error(error);
//     }
//   };


  // const fetchTournamentSlugByOrganizerSlug = async () => {
  //   try {
  //     if (validationResult == 1) {
  //       console.log("apitriggered");
  //       if (!organizer_slug) {
  //         throw new Error("Tournament name is undefined");
  //       }
  //       const response: any = await getTournamentSlugByOrganizerSlug(
  //         organizer_slug
  //       );
  //       setTournamentSlug(response.data);
  //       console.log("response:", response); // log the entire response object
  //       console.log("tournament slug response:", response.data); // log the tournament id
  //     } else {
  //       console.error("Cannot find organization slug");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const fetchTournamentSlugByOrganizerSlug = async () => {
    try {
      if (!organizer_slug) {
        throw new Error("Tournament name is undefined");
      }
      const response: any = await getTournamentSlugByOrganizerSlug(
        organizer_slug
      );
      setTournamentSlug(response.data);
      console.log("response:", response); // log the entire response object
      console.log("tournament slug response:", response.data); // log the tournament id
     
    } catch (error) {
      console.error(error);
    }
    
  };
  return (
    <div>
      <h1 style={{ fontSize: "50px" }}>All Tournaments</h1> <br />
      <br />
      {tournamentSlugArray.map((tournamentSlug: any, index) => {
        return (
          <div>
            {" "}
            <Link
              style={{ textDecoration: "underline" }}
              to={`${tournamentSlug.TournamentSlug}`}
            >
              {tournamentSlug.TournamentSlug}
            </Link>
            <br />
          </div>
        );
      })}
    </div>
  );
};

export default TouranamentList;
